import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getUserFieldValue } from '/src/Util/Util';
const BirthdayMonth = (props) => {
	const { t } = useTranslation();

	const {form_component} = props;
	const {fieldname, required} = form_component;

	const fv = useSelector(state => state.fv);
	const userData = useSelector(state => state.userData);
	let userFieldValue = getUserFieldValue(fieldname, userData);

	useEffect(() => { // to be updated after render
		if (fv && required) {
			fv.addField(`${fieldname}[month]`, {
				validators: {
					notEmpty: {
						message: t('此欄為必須填寫')
					}
				}
			});
		}
	}, [fv]);

	var months = [];
    if (form_component.date_select_na) {
        months[0] = t('不適用');
    }
    for (let i = 1; i <= 12; ++i) {
        months[i] = i;
    }

	return (
		<div className="d-flex align-items-center">
			<div className="me-3">
				<div className="mb-3 form-group select">
					<select
						className="form-select-sm w-date form-select"
						defaultValue={userFieldValue && userFieldValue.month ? userFieldValue.month : ''}
						name={`${fieldname}[month]`}
					>
						<option value="">-</option>
						{(() => {
							const components = [];
							
							months.map((month, index) => {
								components.push(
									<option key={`month-${index}`} value={month}>{month}</option>
								);
							});

							return components;
						})()}
					</select>
				</div>
			</div>
			<div className="pb-3">{t('月')}</div>
		</div>
	);
}

export default BirthdayMonth;